/*
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
//单字段编辑逻辑
import { reactive, toRefs, defineAsyncComponent } from 'vue';
import { layoutService } from '@/api/';
import useViewFields from '@/hooks/view-fields';
import { editFieldTypeList, objectRoleEnum, contractFieldKey, editEntityList, computingStatus } from '@/utils/const';
import { Message } from '@arco-design/web-vue';
// import i18n from '@/locales/index';
import dayjs from 'dayjs';
import { tools } from '@/utils/tools';
import { useUserStore } from '@/store';
import fieldPermission from '@/hooks/field-permission';
export default function useEditFields() {
  const { isEditableField } = fieldPermission();

  const data = reactive({
    redioList: [2, 4], //下拉单选，单选
    selectList: [3, 5], //下拉多选，多选
    numberList: [7, 16, 23], //数字金额百分比
    calculationList: [5, 6, 7, 16, 23], //计算字段类型
    focusList: [0, 1, 7, 11, 16, 23], //需要聚焦且失去焦点保存的字段类型
    specialProduct: [7, 9, 11, 14, 32], //特殊产品对象
    selectFieldTypes: [2, 3, 4, 5, 6, 12, 25, 8, 9, 10], // 需要有下拉框的字段类型
    textFieldTypes: [0, 1, 11], // 文本类型 单行文本 多行文本 超链接
    permissionsObjList: {
      //编辑权限
    },
    // 字段类型常量
    fieldsTypes: {
      attachment: 18, //附件
      number: 7, // 数字
      amount: 16, // 金额
      percent: 23, //百分比
      selectTypes: [2, 3, 4, 5, 9] // 单选、多选、日期范围
    },
    amountPercentFieldTypes: [16, 23],
    popTypes: [8, 9, 10], //日期，日期范围，级联
    setFieldTypesSelect: {
      //下拉框的宽度
      '[2, 3, 4, 5, 6, 12, 25]': '300'
      //   '[8]': '240',
      //   '[9]': '400',
      //   '[10]': '160'
    }
  });
  //   列表及详情字段支持编辑
  const editField = async (params) => {
    if (params) {
      return new Promise((resolve, reject) => {
        layoutService
          .editField(params)
          .then((res) => {
            if (res?.error && res.error?.msg) {
              Message.error(res.error.msg);
            }
            resolve(res);
          })
          .catch((err) => {
            // Message.error(i18n.global.t('系统开小差了，请过后重试'));
            reject(err);
          });
      });
    } else {
      return [];
    }
  };
  //   处理列表及详情可编辑字段值显示
  const setEditFieldVal = (fieldType, fieldValue, fieldExt) => {
    let setFieldValue = fieldValue;
    if (fieldType === 7) {
      //数字
      const getFieldExt = JSON.parse(fieldExt);
      setFieldValue = !isNaN(parseFloat(fieldValue)) ? parseFloat(fieldValue).toFixed(getFieldExt?.numberFormat != 100 ? getFieldExt?.numberFormat : 3) : '';
      // setFieldValue = !isNaN(parseFloat(fieldValue)) ? tools.getNumberShow(setFieldValue,fieldExt) : '';
    } else if (fieldType === 8) {
      //日期
      if (fieldValue) {
        const fe = fieldExt ? fieldExt : fieldValue?.split(' ')?.length > 1 ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
        setFieldValue = dayjs(fieldValue).format(fe);
      } else {
        setFieldValue = '';
      }
    } else if (fieldType === 9) {
      //日期范围
      const hasRangeValue = tools.isJSON(fieldValue) && JSON.parse(fieldValue)?.beginDate && JSON.parse(fieldValue)?.endDate;
      if (hasRangeValue) {
        setFieldValue = tools.isJSON(fieldValue) ? Object.values(JSON.parse(fieldValue))?.join('/') : '';
      } else {
        setFieldValue = '';
      }
    } else if (fieldType === 16) {
      //金额
      setFieldValue = !isNaN(parseFloat(fieldValue)) ? tools.getPriceShow(fieldValue, fieldExt) : '';
    } else if (fieldType === 22) {
      //部门
      setFieldValue =
        (fieldValue &&
          Array.isArray(fieldValue) &&
          fieldValue
            ?.map((i) => {
              return i?.name || i?.departmentName;
            })
            .join(',')) ||
        '';
    } else if (fieldType === 23) {
      //百分比
      setFieldValue = !isNaN(parseFloat(fieldValue)) ? tools.getPercentage(fieldValue, fieldExt) : '';
    }
    return setFieldValue;
  };
  // 部门随机背景色
  const getRandomColor = (index) => {
    const colors = ['#fce3e2', '#fce7cc', '#f8edc0', '#e3f09f', '#d3f5cd', '#c9f2ec', '#ceeffd', '#e1e9ff', '#fce2f2', '#eee6ff']; // 示例色值数组
    const randomIndex = (index + 1) % colors.length;
    return colors[randomIndex - 1];
  };
  // 比较特殊类型的值是否相同
  const compareVal = (params) => {
    let compare = false;
    const fieldValue = params.fieldValue ?? '';
    const oldFieldValue = tools.isJSON(params.oldFieldValue) ? JSON.parse(params.oldFieldValue) : params.oldFieldValue ?? '';
    let getKey = 'id'; //默认部门
    if (params.fieldType == 6) {
      //人员
      getKey = 'userId';
    }
    if (params.fieldType == 18) {
      //附件
      getKey = 'url';
    }
    if (params.fieldType == 25) {
      //查找关联多选
      getKey = 'value';
    }
    if (fieldValue == oldFieldValue) {
      compare = true;
    } else {
      const newValues = fieldValue instanceof Array && new Set(fieldValue?.map((item) => (params.fieldType != 18 ? Number(item[getKey]) : item[getKey])));
      const oldValues = oldFieldValue instanceof Array && new Set(oldFieldValue?.map((item) => (params.fieldType != 18 ? Number(item[getKey]) : item[getKey])));
      // 检查两个集合是否完全相同
      compare = newValues.size === oldValues.size && [...oldValues].every((value) => newValues.has(value));
      //检测附件的顺序有没有变化
      if (params.fieldType == 18 && fieldValue?.length == oldFieldValue?.length) {
        fieldValue?.forEach((item, index) => {
          if (item[getKey] != oldFieldValue[index][getKey]) {
            compare = false;
            return;
          }
        });
      }
    }
    return !compare;
  };
  // 判断编辑之后的值和原始值是否相同
  const getEffective = (params) => {
    const fieldValue = params.fieldValue ?? '';
    const oldFieldValue = params.oldFieldValue ?? '';
    // console.log('fieldValue', fieldValue);
    // console.log('oldFieldValue', oldFieldValue);

    let isSame = true;
    if ((data.focusList.includes(params.fieldType) || data.redioList.includes(params.fieldType)) && fieldValue === oldFieldValue) isSame = false; //单行、多行文本、单选、下拉单选、超链接、数字，金额、百分比

    if (params.fieldType == 8) {
      // 日期类型后端数据会补为时分秒，需要特殊比对
      const normalizeDate = (str) => {
        let fixed = str.replace(/-/g, '/');
        if (fixed.length === 16) fixed += ':00'; // 如果缺少秒数，补全 兼容特殊浏览器对时分秒的解析
        return new Date(fixed);
      };
      const oldTime = normalizeDate(oldFieldValue);
      const newTime = normalizeDate(fieldValue);

      // console.log('日期新旧值', oldTime, newTime,  oldTime.getTime() === newTime.getTime());

      if (oldTime.getTime() === newTime.getTime() || oldFieldValue === fieldValue) isSame = false;
    }

    if (data.selectList.includes(params.fieldType) || params.fieldType == 9 || params.fieldType == 10) {
      //多选/下拉多选/日期范围/级联
      const getOldFieldValue = oldFieldValue instanceof Array ? oldFieldValue?.join('/') : oldFieldValue;
      const getNewfieldValue = fieldValue instanceof Array ? fieldValue?.filter((i) => i != '')?.join('/') : fieldValue;

      if (getOldFieldValue === getNewfieldValue) isSame = false;
    }
    if (params.fieldType == 12 && (oldFieldValue?.value == fieldValue?.value || fieldValue == oldFieldValue)) isSame = false;

    if ([6, 22, 25, 18].includes(params.fieldType)) {
      //人员，部门，查找关联多选,附件
      isSame = compareVal(params);
    }
    if (params.fieldType == 26 && (fieldValue == oldFieldValue || (fieldValue === '<p><br></p>' && !oldFieldValue) || (oldFieldValue === '<p><br></p>' && !fieldValue))) isSame = false;

    return isSame;
  };
  // 校验数据格式
  const checkFormat = (params) => {
    const fieldValue = params.fieldValue ?? '';
    let isIncorrect = true;
    if (params.fieldType == 18 && params?.filesList && params?.allFiles && params.filesList?.length != params.allFiles?.length) {
      Message.warning('文件未上传完成,请稍后提交！');
      isIncorrect = false;
    }
    if (params.fieldType == 11 && fieldValue && !tools.checkLink(fieldValue)) {
      Message.warning('格式不正确，请以http:// 或 https:// 开头，且不能包含汉字!');

      isIncorrect = false;
    }
    return isIncorrect;
  };
  //  校验必填状态
  const checkRequired = (params) => {
    const fieldValue = params.fieldValue ?? '';
    let isPass = true;
    if (params.fieldKey == 'personName' && params.type == 1) {
      //联系人且是基础字段
      if (!fieldValue) {
        isPass = false;
        Message.warning('默认联系人不可清空!');
      }
    } else {
      if (params?.isRequired) {
        //必填校验
        if ((data.numberList.includes(params.fieldType) && isNaN(parseFloat(fieldValue))) || (!data.numberList.includes(params.fieldType) && (!fieldValue || fieldValue?.length == 0)) || (params.fieldType == 12 && !fieldValue?.value) || (params.fieldType == 25 && !fieldValue?.length)) {
          isPass = false;
        } else if (params.fieldType == 18 && params.filesList?.length == 0 && (!fieldValue || fieldValue?.length == 0)) {
          //附件
          isPass = false;
        } else if (params.fieldType == 26 && (fieldValue === '<p><br></p>' || !fieldValue || !tools.handleRichText(fieldValue))) {
          //富文本
          isPass = false;
        }
      }
      if (!isPass) {
        Message.warning('必填字段不能为空!');
      }
    }

    return isPass;
  };
  // 处理编辑之后上传的参数
  const setFieldVal = (params) => {
    let setFieldValue = params.fieldValue ?? '';
    const fieldType = params.fieldType;
    if (data.selectList.includes(fieldType)) {
      //多选/下拉多选特殊处理
      setFieldValue = setFieldValue && Array.isArray(setFieldValue) ? setFieldValue?.filter((i) => i != '')?.join(',') : '';
    } else if (fieldType == 9) {
      //日期
      const hasValue = tools.hasDateRange(setFieldValue);
      const v = { beginDate: setFieldValue?.[0], endDate: setFieldValue?.[1] };
      setFieldValue = hasValue ? JSON.stringify(v) : '';
    } else if (fieldType == 10) {
      //级联
      setFieldValue = setFieldValue && Array.isArray(setFieldValue) ? setFieldValue?.join('/') : '';
    } else if (fieldType === 16) {
      //金额
      setFieldValue = !isNaN(parseFloat(setFieldValue)) ? tools.setPrice(setFieldValue) : '';
    } else if (fieldType === 18) {
      let updateFieldValue = params.filesList?.length > 0 ? params.filesList : params.fieldValue;
      if (Array.isArray(updateFieldValue) && updateFieldValue?.length > 0) {
        updateFieldValue = updateFieldValue?.map((v) => {
          return {
            url: v?.url || '',
            name: v?.name || ''
          };
        });
        setFieldValue = JSON.stringify(updateFieldValue);
      } else {
        setFieldValue = '';
      }
    } else if (fieldType === 23) {
      //百分比
      setFieldValue = !isNaN(parseFloat(setFieldValue)) ? tools.setPercentage(setFieldValue, JSON.parse(params.fieldExt).numberFormat) : '';
    } else if (fieldType === 12) {
      setFieldValue = setFieldValue?.value || null;
    } else if (fieldType === 22 || fieldType === 6) {
      setFieldValue = (setFieldValue && Array.isArray(setFieldValue) && setFieldValue?.map((u) => u?.id || u?.userId)?.join(',')) || '';
    } else if (fieldType === 25) {
      setFieldValue = setFieldValue?.map((v) => v.value) || null;
    } else if (fieldType === 26) {
      if (setFieldValue === '<p><br></p>') {
        setFieldValue = '';
      }
    }
    // console.log('setFieldValue', params, setFieldValue);

    return setFieldValue;
  };
  // 获取编辑之后的值
  const getFieldVal = (params) => {
    const { showFieldsLabel } = useViewFields();
    //保存人员、部门选择的原值
    //只有列表处理-日期
    let getFieldValue = params.fieldValue;
    const fieldType = params.fieldType;
    const fieldExt = params.fieldExt;

    // 列表和详情都要处理的逻辑（单选，多选，级联）
    if (data.selectList.includes(fieldType) || fieldType == 10 || data.redioList.includes(fieldType)) {
      const tempFields = showFieldsLabel(getFieldValue, fieldExt, fieldType);

      if (fieldType == 2 || fieldType == 4) {
        //单选，下拉单选
        getFieldValue = tempFields ?? '';
      }
      if (fieldType == 3 || fieldType == 5) {
        //下拉多选，多选
        getFieldValue = Array.isArray(getFieldValue) && getFieldValue?.length > 0 ? tempFields?.split('/')?.join(',') : '';
      }
      if (fieldType == 10) {
        //级联
        getFieldValue = Array.isArray(getFieldValue) && getFieldValue?.length > 0 ? tempFields : '';
      }
    } else if (fieldType == 8) {
      //日期
      if (getFieldValue) {
        const fe = fieldExt ? fieldExt : getFieldValue?.split(' ')?.length > 1 ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
        getFieldValue = dayjs(getFieldValue).format(fe);
      } else {
        getFieldValue = '';
      }
    } else if (fieldType == 9) {
      //日期范围
      if (getFieldValue) {
        const showRangValue = {
          beginDate: getFieldValue?.[0],
          endDate: getFieldValue?.[1]
        };
        getFieldValue = JSON.stringify(showRangValue);
      } else {
        getFieldValue = '';
      }
    }
    return getFieldValue;
  };
  // 附件的信息（移动端的配置不支持编辑）
  //   const getFieldExtUploadType = (fieldItem) => {
  //     return fieldItem?.fieldExt && tools.isJSON(fieldItem.fieldExt) ? JSON.parse(fieldItem.fieldExt) : fieldItem?.fieldExt || null;
  //   };
  // 设置对象编辑权限码
  const setPermissions = (entity) => {
    for (const key in objectRoleEnum) {
      if (!data.specialProduct.includes(Number(key))) {
        data.permissionsObjList[key] = objectRoleEnum[key] + ':edit';
      }
    }

    //兼容自定义
    if (entity >= 200) {
      data.permissionsObjList[entity] = `${entity}:edit`;
    }
  };
  // 判断字段是否可编辑
  // const fieldIsEditable = (getFieldParams) => {
  //   const fieldKey = getFieldParams.fieldKey;
  //   const businessFieldType = getFieldParams?.col?.fieldType; //引用类型
  //   const fieldType = getFieldParams.fieldType;
  //   const colType = getFieldParams.col.type;
  //   //此处判断是否是子表单子字段
  //   const isPermissionEdit = isEditableField(getFieldParams.subFieldFullKey ?? fieldKey, getFieldParams?.PERMISSION); //业务规则是否可编辑
  //   return isPermissionEdit && !['businessId', 'entityType'].includes(fieldKey) && businessFieldType !== 21 && !editFieldTypeList?.includes(fieldType) && colType != 0 && ((getFieldParams.entity >= 200 && fieldKey != 'chargePerson') || (getFieldParams.entity < 200 && !editEntityList[getFieldParams.entity]?.includes(fieldKey))) && !contractFieldKey.includes(fieldKey);
  // };
  const fieldIsEditable = (getFieldParams) => {
    const { fieldKey, fieldType, col: { fieldType: businessFieldType, type: colType } = {}, subFieldFullKey, PERMISSION, entity } = getFieldParams;

    // 1. 检查字段规则权限

    //console.log('字段规则权限',getFieldParams?.row,PERMISSION, isEditableField(subFieldFullKey ?? fieldKey, PERMISSION, getFieldParams?.row?.businessData))

    if (!isEditableField(subFieldFullKey ?? fieldKey, PERMISSION, getFieldParams?.row?.businessData)) {
      return false;
    }

    // 2. 排除特定字段
    if (['businessId', 'entityType'].includes(fieldKey)) {
      return false;
    }

    // 3. 排除引用字段
    if (businessFieldType == 21) {
      return false;
    }

    // 4. 排除特定字段类型（不可编辑的字段）
    if (editFieldTypeList?.includes(fieldType)) {
      return false;
    }

    // 5. 排除系统字段
    if (colType == 0) {
      return false;
    }

    // 6. 根据实体类型处理不同逻辑
    if (entity >= 200) {
      //自定义对象
      if (fieldKey == 'chargePerson') {
        return false;
      }
    } else {
      if (editEntityList[entity]?.includes(fieldKey)) {
        //系统对象

        return false;
      }
    }

    // 7. 排除合同相关字段
    if (contractFieldKey.includes(fieldKey)) {
      return false;
    }

    // 所有条件都通过，字段可编辑
    return true;
  };
  // 设置不可编辑提示
  //   const setWarningMessage = (fieldItem, init = false) => {
  //     const { userInfo } = useUserStore(); //用户信息
  //     // console.log('fieldItem', fieldItem);

  //     setPermissions(fieldItem.entity);
  //     // console.log('userInfo', userInfo, data.permissionsObjList);
  //     if (fieldItem?.row?.computedInfo?.status == 1 || (fieldItem?.row.lockedOrigin && fieldItem.entity != 101) || (fieldItem.fieldType == 18 && getFieldExtUploadType(fieldItem)?.uploadType == 2 && getFieldExtUploadType(fieldItem)?.fileType == 2)) {
  //       if (!init) Message.warning('当前数据状态不支持编辑');

  //       return false;
  //     }
  //     if (fieldItem?.permissions != 1 || userInfo?.roles?.indexOf(data.permissionsObjList[fieldItem.entity]) == -1) {
  //       if (!init) Message.warning('你没有权限编辑此字段');
  //       return false;
  //     }

  //     return true;
  //   };

  // 设置不可编辑提示
  const setWarningMessage = (fieldItem, init = false) => {
    const { userInfo } = useUserStore();

    // Set permissions for the entity
    setPermissions(fieldItem.entity);

    // Check if field is editable based on status/locked state
    const isFieldLocked = computingStatus.includes(fieldItem?.row?.computedInfo?.status) || (fieldItem?.row.lockedOrigin && fieldItem.entity != 101);

    if (isFieldLocked) {
      if (!init) Message.warning('当前数据状态不支持编辑');
      return false;
    }

    const hasEditPermission = fieldItem?.permissions == 1 && userInfo?.roles?.includes(data.permissionsObjList[fieldItem.entity]);

    if (!hasEditPermission) {
      if (!init) Message.warning('你没有权限编辑此字段');
      return false;
    }

    return true;
  };
  // 监控上下左右键码
  const stopKeydown = (e) => {
    const keyCodes = [37, 38, 39, 40];
    if (keyCodes.includes(e.keyCode)) {
      e.preventDefault();
    }
  };
  // 辅助函数用于动态懒加载导入组件
  const loadComponent = (path) => import(`@/components/fh-set-fields/components/field-edit/${path}/index.vue`);
  // 字段编辑组件
  const textFields = defineAsyncComponent(() => loadComponent('text')); //单行文本，多行文本，超链接，自增编码
  const personnel = defineAsyncComponent(() => loadComponent('personnel')); //人员
  const depart = defineAsyncComponent(() => loadComponent('depart')); //部门
  const amount = defineAsyncComponent(() => loadComponent('amount')); //金额
  const percent = defineAsyncComponent(() => loadComponent('percent')); //百分比
  const selectFields = defineAsyncComponent(() => loadComponent('select')); //选项类型
  const association = defineAsyncComponent(() => loadComponent('association')); //查找关联单/多
  const dateFields = defineAsyncComponent(() => loadComponent('date')); //日期，日期范围
  const numberField = defineAsyncComponent(() => loadComponent('number')); //数字
  const attachment = defineAsyncComponent(() => loadComponent('attachment')); //附件
  const calculated = defineAsyncComponent(() => loadComponent('calculated')); //计算字段
  const richText = defineAsyncComponent(() => loadComponent('rich-text')); //富文本
  const cascadeFields = defineAsyncComponent(() => loadComponent('cascade')); //级联
  // 动态导入编辑组件
  const getfieldCom = {
    0: textFields,
    1: textFields,
    2: selectFields,
    3: selectFields,
    4: selectFields,
    5: selectFields,
    6: personnel,
    7: numberField,
    8: dateFields,
    9: dateFields,
    10: cascadeFields,
    11: textFields,
    12: association,
    13: textFields,
    16: amount,
    18: attachment,
    21: textFields,
    22: depart,
    23: percent,
    24: calculated,
    25: association,
    26: richText
  };

  // 设置字段右侧间距的字段类型
  const textRightAlign = (fields) => {
    if (data.numberList.includes(fields.fieldType)) {
      // 数字/金额/百分比靠右展示
      return true;
    }
    if (fields.fieldType === 24) {
      //计算字段
      const type = tools.isJSON(fields.fieldExt) ? JSON.parse(fields.fieldExt)?.type ?? 7 : 7;
      if (data.calculationList.includes(type)) {
        return true;
      }
    }
    return false;
  };
  // 字段编辑回调组织参数(cbParams:回调参数，fields：字段信息，)
  const assemblyParameters = (cbParams, fields) => {
    // 构建基础参数
    const params = {
      fieldValue: cbParams.fieldValue,
      fieldType: fields.fieldType,
      oldFieldValue: fields.oldFieldValue.fieldValue,
      isRequired: fields.isRequired,
      fieldExt: fields?.fieldExt,
      fieldKey: fields.fieldKey,
      type: fields?.col?.type
    };

    // 根据不同字段类型处理参数
    const currentFieldType = fields.fieldType;
    // 处理附件类型
    if (currentFieldType === data.fieldsTypes.attachment) {
      Object.assign(params, {
        filesList: cbParams.filesList,
        allFiles: cbParams.allFiles
      });
    }

    // 处理选择类型字段（单选、多选、日期范围）
    if (data.fieldsTypes.selectTypes.includes(currentFieldType)) {
      params.oldFieldValue = cbParams.oldFieldValue;
    }

    // 处理数字类型
    if (currentFieldType === data.fieldsTypes.number) {
      params.oldFieldValue = params.oldFieldValue ? Number(params.oldFieldValue) : null;
    }

    // 处理金额和百分比类型
    if ([data.fieldsTypes.amount, data.fieldsTypes.percent].includes(currentFieldType)) {
      params.oldFieldValue = cbParams.oldFieldValue ? Number(cbParams.oldFieldValue) : null;
    }

    return params;
  };

  // 设置下拉框的高度
  const setSelectHeight = (selectParames) => {
    let setMaxHeight = selectParames.maxHeight;
    let setMinHeight = selectParames.minHeight;
    const remainingBottomHeight = selectParames.getBodyScrollHeight - selectParames.getParentStyleTop - selectParames.previewClientHeight; //底部剩余空间
    const remainingTopHeight = selectParames.getParentStyleTop; //顶部剩余空间
    if (remainingBottomHeight < selectParames.maxHeight) {
      //底部空间不够
      if (remainingTopHeight < selectParames.maxHeight) {
        //顶部空间也不够时
        if (remainingBottomHeight > remainingTopHeight) {
          //底部剩余空间大于顶部空间
          setMaxHeight = remainingBottomHeight - 10;
          setMinHeight = remainingBottomHeight - 10;
        } else {
          setMaxHeight = remainingTopHeight;
          setMinHeight = remainingTopHeight;
        }
      }
    }
    if (remainingBottomHeight == 370) {
      setMaxHeight = 360;
      setMinHeight = 160;
    }
    return {
      maxHeight: setMaxHeight,
      minHeight: setMinHeight
    };
  };
  // 获取下拉框的宽度
  const setSelectWidth = (fieldType) => {
    let getSelectWidth;
    for (const key in data.setFieldTypesSelect) {
      // 将键字符串转换为数组（例如："[2, 3, 4]" → [2, 3, 4]）
      const fieldTypes = key
        .replace(/\[|\]/g, '') // 移除方括号
        .split(',') // 按逗号分割
        .map(Number); // 转换为数字
      if (fieldTypes.includes(fieldType)) {
        getSelectWidth = data.setFieldTypesSelect[key];
        break; // 找到匹配项后停止循环
      }
    }
    return getSelectWidth;
  };
  // 是否是固定列
  const isFixed = (columns, fields) => {
    const currentField = columns?.find((item) => item.colKey == fields?.fieldKey);
    if (currentField?.fixed === 'left') {
      return true;
    }
    return false;
  };
  let currentScrollHandler = null;
  // 监听表格滚动事件
  const handleTbodyScroll = (parames) => {
    const tableBodyList = document.querySelectorAll('.qf-table-header-body');

    // 如果存在旧的事件处理函数，先解绑
    if (currentScrollHandler) {
      tableBodyList.forEach((tBody) => {
        tBody.removeEventListener('scroll', currentScrollHandler);
      });
      currentScrollHandler = null;
    }
    if (parames?.type == 1) {
      //  监听

      let updateSelectLeft = 0;
      let updateContentLeft = 0;

      //非固定列
      currentScrollHandler = () => {
        const tbodyRect = parames?.getTbody1?.getBoundingClientRect?.(); //一级表体
        const getTbodyLevel = parames?.getTbodyLevel; //多层级
        const tbodyLevelRect = getTbodyLevel?.getBoundingClientRect?.(); //多层级表格表体
        const getCellRect = document.querySelectorAll(`.${parames.parentCellClass}`)?.[0]?.getBoundingClientRect(); //单元格

        updateSelectLeft = getCellRect?.left - tbodyRect?.left;
        updateContentLeft = getCellRect?.left - tbodyRect?.left;

        if (!isFixed(parames.columns, parames.fields)) {
          const getFieldType = parames.fields.fieldType;

          //多层级
          if (parames.fields?.tableLevel > 1 || parames.isAssTable) {
            if (!getCellRect || !tbodyRect) return;

            // 触发回调通知位置更新
            const levelCellLeft = getCellRect?.left - tbodyLevelRect?.left + getTbodyLevel?.scrollLeft;
            const remainingWidth = tbodyLevelRect?.width - levelCellLeft; //右侧剩余空间
            //右侧空间不够时
            let getSelectWidth = setSelectWidth(getFieldType);
            if (data.popTypes.includes(getFieldType)) {
              ///8, 9, 10
              getSelectWidth = document.getElementsByClassName(`${parames.contentCellClass}-pop-container`)?.[0]?.clientWidth;
            }

            if (getSelectWidth && remainingWidth < getSelectWidth) {
              updateSelectLeft = updateSelectLeft - getSelectWidth + getCellRect?.width;
            }
            const getContentWidth = document.getElementsByClassName(`${parames.contentCellClass}`)?.[0]?.offsetWidth;

            if (getContentWidth && remainingWidth < getContentWidth) {
              updateContentLeft = updateContentLeft - (getContentWidth - parames.contentWidth);
            }
            parames.onPositionChange({ selectLeft: updateSelectLeft, contentLeft: updateContentLeft });
          }

          if (parames?.getTableFixedBody) {
            //左侧的字段被遮盖的情况
            if ((parames.fields?.tableLevel != 1 || parames.isAssTable) && parames?.getTableFixedBody?.right > getCellRect?.left) {
              //非一级表格，关闭编辑状态
              parames.closeModal();
            }
            //2026年01月09日17:01:08调整为编辑气泡触碰到左侧固定列时，立即关闭编辑状态
            // - getCellRect?.width
            if (parames.fields?.tableLevel == 1 && parames?.getTableFixedBody?.right > getCellRect?.left) {
              //一级表格左侧的字段被遮盖的情况
              // parames.onClose();
              parames.closeModal();
            }
          }
        } else {
          //固定列

          if (parames.fields?.tableLevel <= 1) {
            //一级表格，或者分组
            updateSelectLeft += parames?.getTbody1?.scrollLeft;
            updateContentLeft += parames?.getTbody1?.scrollLeft;
          }
          parames.onPositionChange({ selectLeft: updateSelectLeft, contentLeft: updateContentLeft });
        }
      };
      tableBodyList?.forEach((tBody) => {
        tBody.addEventListener('scroll', currentScrollHandler);
      });
    }
  };
  return {
    checkRequired,
    editField,
    checkFormat,
    setFieldVal,
    getEffective,
    setEditFieldVal,
    getFieldVal,
    fieldIsEditable,
    setWarningMessage,
    setPermissions,
    getRandomColor,
    stopKeydown,
    getfieldCom,
    textRightAlign,
    assemblyParameters,
    setSelectHeight,
    setSelectWidth,
    handleTbodyScroll,
    isFixed,
    ...toRefs(data)
  };
}
